import Translator from '../utils/translator';

document.addEventListener('DOMContentLoaded', () => {
    Translator._autoload();
});
